import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-amber-500/20 last:border-0" data-id="element-5">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex justify-between items-center text-left focus:outline-none group" data-id="element-6">
        <span className="text-lg font-semibold text-stone-200 group-hover:text-amber-400 transition-colors pr-4" data-id="element-7">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-stone-500 transition-transform duration-300 ${isOpen ? 'rotate-180 text-amber-400' : ''}`} data-id="element-8" />
      </button>
      <AnimatePresence data-id="element-9">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-10">
            <div className="pb-6 text-stone-400 leading-relaxed" data-id="element-11">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  const faqs = [{
    question: 'Will this work if my cycle is irregular?',
    answer: "Absolutely. FLOW-4™ helps you understand your unique patterns, even if they're not textbook-perfect. Many women notice more regularity once they start honoring their rhythm."
  }, {
    question: "I'm on birth control. Can I still use this?",
    answer: "Yes. While birth control affects your natural cycle, the principles of energy management, nutrition, and self-care still apply. You'll learn to tune into your body's subtle rhythms."
  }, {
    question: 'How much time does this take daily?',
    answer: 'Just 7 minutes a day. Designed for real, busy lives. Even small shifts create powerful results.'
  }, {
    question: 'Is this backed by science?',
    answer: "Yes. Cycle syncing is based on well-established hormonal research. We've translated the science into practical, usable steps."
  }, {
    question: "What if I don't have a regular 28-day cycle?",
    answer: 'No problem. Whether your cycle is 25 days or 31, the four phases still exist. FLOW-4™ shows you how to identify and work with them.'
  }, {
    question: "Can I get a refund if it doesn't work for me?",
    answer: "Yes. We offer a 7-day money-back guarantee. If you don't feel more aligned and balanced, simply email us for a full refund."
  }];
  return <div className="max-w-3xl mx-auto" data-id="element-12">
      {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-13" />)}
    </div>;
}